import aimmaConsultPreview from "../../../image/health/aimma-patient/aimma-consult-preview.png";
import aimmaInterviewPreview from "../../../image/health/aimma-patient/aimma-interview-preview.png";
import aimmaRecordPreview from "../../../image/health/aimma-patient/aimma-record-preview.png";
import patientIntakeMobile from "../../../image/health/aimma-patient/patient-intake-mobile.png";

export const healthAimmaPatientPreviewAssets: Record<string, string> = {
    "patient-intake-mobile": patientIntakeMobile,
    "aimma-interview": aimmaInterviewPreview,
    "aimma-interview-preview": aimmaInterviewPreview,
    "aimma-diary": aimmaRecordPreview,
    "aimma-record-preview": aimmaRecordPreview,
    "aimma-consultation": aimmaConsultPreview,
    "aimma-consult-preview": aimmaConsultPreview,
};

export function getAimmaPatientModulePreviewSrc(
    productId: string | undefined
): string | undefined {
    if (!productId) return undefined;
    return healthAimmaPatientPreviewAssets[productId];
}

export function getAimmaPatientVisualPreviewSrc(
    assetKey: string | undefined
): string | undefined {
    if (!assetKey) return undefined;
    return healthAimmaPatientPreviewAssets[assetKey];
}
